module.exports = __webpack_public_path__ + "img/4.10ceb705.jpg";